import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from "../../AbstractElements";
import SampleCollectionHome from "./SampleCollectionHome";

export default function SampleCollectionList() {
    return (
        <Fragment>
            <Breadcrumbs
                mainTitle="Sample Collection"
                parent="Home"
                title="Sample Collection"
            />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <SampleCollectionHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}
